import React, {useEffect} from 'react';
import {ScrollView} from 'react-native';
import {makeStyles} from '@rneui/themed';
import {observer} from 'mobx-react';

import BaseTile from '../../components/articleTile/BaseTile';
import LoadingImg from '../../components/LoadingImg';
import ContentView from '../../components/ui-controls/layout/ContentView';
import WebFooter from '../../components/WebFooter';
import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {useStores} from '../../stores/use-stores';

const ExclusiveOfferListScreen = observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.EXCLUSIVE_OFFER_LIST>) => {
    const {offersStore, shopSelectionStore, rewardsStore} = useStores();

    const {isWebDesktopScreen} = useWebScreenDimensions();

    const styles = useStyles();

    // Redirect to home if no rewards
    useEffect(() => {
      if (!rewardsStore.hasRewards) {
        navigation.navigate(AppRoute.HOME);
      }
    }, [navigation, rewardsStore.hasRewards]);

    return (
      <ContentView testID={'exclusive-offer-list-screen'}>
        <ScrollView
          showsVerticalScrollIndicator={isWebDesktopScreen}
          showsHorizontalScrollIndicator={isWebDesktopScreen}>
          {!!shopSelectionStore.storeLoading && <LoadingImg />}
          {!shopSelectionStore.storeLoading && (
            <>
              {offersStore.data?.map(offer => (
                <BaseTile
                  key={offer.mflId}
                  item={{
                    id: offer.mflId,
                    heroImage: offer.heroImage?.[0],
                    heroImageWeb: offer.heroImageDesktop?.[0],
                    headline: offer.headline,
                    bannerHeadline: offer.tileHeadline,
                    description: offer.description,
                  }}
                  customStyles={styles}
                  pressCallback={() => {
                    navigation.navigate(AppRoute.EXCLUSIVE_OFFER_DETAIL, {
                      mflId: offer.mflId,
                    });
                  }}
                  includeByline={true}
                  isWebDesktopScreen={isWebDesktopScreen}
                />
              )) || null}
              {!!isWebDesktopScreen && <WebFooter />}
            </>
          )}
        </ScrollView>
      </ContentView>
    );
  },
);

const useStyles = makeStyles(() => ({
  container: {
    marginHorizontal: 0,
  },
  touchable: {
    marginBottom: 8,
  },
  textHolder: {
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  headline: {
    marginTop: 4,
    marginBottom: 4,
  },
}));

export default ExclusiveOfferListScreen;
